










































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Order, OrderStatus } from '@/interfaces/order.interface';
import OrderStatusField from '@/components/OrderStatusField.vue';
import PermissionsService from '../services/permissions.service';
import { namespace } from 'vuex-class';
import { User } from '@/interfaces/user.interface';
import { isEmptyObject } from '@/helpers/helpers';
import StatusConfirmation from "@/components/StatusConfirmation.vue";

const ordersModule = namespace('orders');
const usersModule = namespace('users');

@Component({
  components: {
    StatusConfirmation,
    OrderStatusField
  }
})
export default class OrderDetailsFields extends Vue {
  @Prop() order!: Order;
  shipperExpanded = false;
  consigneeExpanded = false;
  isConfirmationModalVisible = false;
  @usersModule.Getter currentUser!: User;
  @usersModule.State users!: User[];
  @ordersModule.Action update!: any;
  @ordersModule.State statuses!: OrderStatus[];

  getUserSelectLabel(user: User) {
    return `${user.firstName} ${user.lastName}`;
  }

  isEmpty(obj: any) {
    return isEmptyObject(obj);
  }

  toggleShipper(): void {
    this.shipperExpanded = !this.shipperExpanded;
  }

  toggleConsignee(): void {
    this.consigneeExpanded = !this.consigneeExpanded;
  }

  toggleConfirmationModal(): void {
    this.isConfirmationModalVisible = !this.isConfirmationModalVisible;
  }

  getOrderDetails(): any {
    return [
      {label: 'Job Number', value: this.order.jobNumber},
      {label: 'Order Number', value: this.order.orderNumber},
      {label: 'Project Number', value: this.order.projectNumber},
      {label: 'Customer Name', value: this.order.customerName},
      {label: 'Transport Mode', value: this.order.transportMode && this.order.transportMode.name},
      {
        label: 'Priority',
        value: this.order.priority && `${this.order.priority.name} (${this.order.priority.details})`
      },
      {label: 'Notes', html: this.preserveNewLines(this.order.notes)},
      {spacer: true},
      {label: 'Is Hazardous', value: this.order.isHazardous},
      {label: 'Hazardous Un Code', value: this.order.hazardousUnCode},
      {label: 'Hazardous Class', value: this.order.hazardousClass},
      {label: 'Customs', value: this.order.customs},
      {
        label: 'Customs Value',
        value: this.order.customsValue && `${this.order.customsValue} ${this.order.customsCurrency}` || ''
      },
      {spacer: true}
    ];
  }

  get canUpdateOrderStatus(): boolean {
    if (this.currentUser && this.currentUser.roleName && this.order.status && this.order.status.name) {
      return PermissionsService.can('orders', 'update')
          && ['admin_a', 'admin_b'].indexOf(this.currentUser.roleName) > -1
          && this.order.status.name !== 'Pending';
    }
    return false;
  }

  get isCancelButtonVisible(): boolean {
    if (this.currentUser && this.currentUser.roleName && this.order.status && this.order.status.name && this.order.status.name !== 'Cancelled') {
      return ['user_a', 'user_b'].indexOf(this.currentUser.roleName) > -1
          || (['admin_a', 'admin_b', 'user_a', 'user_b'].indexOf(this.currentUser.roleName) > -1 && this.order.status.name === 'Pending');
    }
    return false;
  }

  get isReadyButtonVisible(): boolean {
    if (this.currentUser && this.currentUser.roleName && this.order && this.order.status) {
      return this.currentUser.roleName === 'admin_c' && this.order.status.name === 'Packing';
    }
    return false;
  }

  cancelOrder(confirmed: boolean) {
    if (!confirmed) {
      this.toggleConfirmationModal()
      return;
    }

    const cancelledStatus = this.statuses.find((s: OrderStatus) => s.name === 'Cancelled');
    if (!cancelledStatus) return;

    const order: Order = {
      ...this.order,
      ...{
        status: cancelledStatus
      }
    };
    this.update({order});

    this.toggleConfirmationModal()
  }

  setStatusToReadyForShipping() {
    const rfsStatus = this.statuses.find((s: OrderStatus) => s.name === 'Ready for shipping');
    if (!rfsStatus) return;

    const order: Order = {
      ...this.order,
      ...{
        status: rfsStatus
      }
    };
    this.update({order});
  }


  get canEditLogisticsUser() {
    return this.currentUser && this.currentUser.roleName === 'admin_a';
  }

  updateLogisticsUser() {
    this.update({order: this.order});
  }

  private preserveNewLines(s: string | undefined) {
    if (!s) return '';
    return s.replace(/\n/g, '<br>');
  }
}
